(() => {
  const mounted = new WeakMap();

  function mountHeader(header) {
    if (mounted.has(header)) return;
    const abortController = new AbortController();
    const { signal } = abortController;
    const drawer = header.querySelector('[data-rd-menu]');
    const trigger = header.querySelector('[data-rd-menu-open]');
    const closeButton = header.querySelector('[data-rd-menu-close]');
    const dropdowns = [...header.querySelectorAll('.rd-nav-dropdown')];
    const desktop = window.matchMedia('(min-width: 990px)');

    const closeDropdowns = (except = null) => dropdowns.forEach((details) => {
      if (details !== except) details.open = false;
    });
    const resetDrawer = () => {
      trigger?.setAttribute('aria-expanded', 'false');
      if (!document.querySelector('[data-rd-menu][open]')) document.body.classList.remove('rd-menu-is-open');
    };
    const closeDrawer = () => {
      if (drawer?.open) drawer.close();
      resetDrawer();
    };

    trigger?.addEventListener('click', () => {
      if (!drawer || typeof drawer.showModal !== 'function') return;
      closeDropdowns();
      if (!drawer.open) drawer.showModal();
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('rd-menu-is-open');
      closeButton?.focus();
    }, { signal });
    closeButton?.addEventListener('click', closeDrawer, { signal });
    drawer?.addEventListener('close', resetDrawer, { signal });
    drawer?.addEventListener('click', (event) => {
      if (event.target === drawer) {
        const box = drawer.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDrawer();
      }
      if (event.target.closest('a[href]')) closeDrawer();
    }, { signal });

    dropdowns.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.open) closeDropdowns(details);
      }, { signal });
      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          details.open = false;
          details.querySelector('summary')?.focus();
        }
      }, { signal });
      details.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !details.contains(event.relatedTarget)) details.open = false;
      }, { signal });
    });
    document.addEventListener('click', (event) => {
      dropdowns.forEach((details) => {
        if (details.open && !details.contains(event.target)) details.open = false;
      });
    }, { signal });
    desktop.addEventListener('change', (event) => {
      if (event.matches) closeDrawer();
      else closeDropdowns();
    }, { signal });
    mounted.set(header, () => {
      closeDrawer();
      abortController.abort();
      mounted.delete(header);
    });
  }

  const mount = (scope = document) => {
    if (scope.matches?.('[data-rd-header]')) mountHeader(scope);
    scope.querySelectorAll('[data-rd-header]').forEach(mountHeader);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-rd-header]').forEach((header) => mounted.get(header)?.());
  });
})();
